import { writable } from 'svelte/store'

export const modalStore = $modalStore()
export const refreshStore = writable(null)
export const eventStore = writable(null)

export const accountsStore = items([])
export const chargesStore = items([])
export const coursesStore = items([])
export const creditsStore = items([])
export const facturamaInvoicesStore = items([])   
export const fixedpricesStore = items([])
export const foliosStore = items([])
export const invoicesStore = items([])   
export const noticesStore = items([])
export const notificationsAdminStore = items([])
export const notificationsStore = items([])
export const ordersStore = items([])
export const pickupsStore = items([])
export const prepaidsStore = items([])
export const pricingsStore = items([])
export const providersStore = items([])
export const shipmentsStore = items([])
export const shopifysStore = items([])
export const stpOrdenesStore = items([])
export const suscriptionsStore = items([])
export const ticketsStore = items([])
export const tipsStore = items([])
export const transactionsStore = items([])
export const tutorialsStore = items([])
export const usersStore = items([])
export const billingsStore = items([])
export const pricesStore = items([])
export const incidentsStore = items([])
export const merchandisesStore = items([])
export const stocksStore = items([])
export const reviewsInvoicesStore = items([])
export const reviewsSupportsStore = items([])
export const userStatisticsStore = items([])
export const userTracingsStore = items([])
export const estafetaPaymentsStore = items([])
export const clientsStore = items([])
export const tracingsStore = items([])
export const productsStore = items([])
export const categoriesStore = items([])
export const errorsStore = items([])
export const providersInvoicesStore = items([])
export const providersPaymentsStore = items([])
export const providersShoppingsStore = items([])

export const accountingIMSSsStore = items([])
export const accountingIMSSDocumentsStore = items([])
export const accountingPayrollsStore = items([])
export const accountingStatementsStore = items([])

export const accountStore = writable(null)
export const adminStore = writable(null)
export const chargeStore = writable(null)
export const courseStore = writable(null)
export const creditStore = writable(null)
export const facturamaClientStore = writable(null)
export const fixedpriceStore = writable(null)
export const folioStore = writable(null)
export const invoiceStore = writable(null)
export const noticeStore = writable(null)
export const notificationStore = writable(null)
export const notifyStore = writable(null)
export const orderStore = writable(null)
export const pickupStore = writable(null)
export const prepaidStore = writable(null)
export const pricingStore = writable(null)
export const providerStore = writable(null)
export const shipmentStore = writable(null)
export const shopifyStore = writable(null)
export const stpOrdenStore = writable(null)
export const suscriptionStore = writable(null)
export const ticketStore = writable(null)
export const tipStore = writable(null)
export const tutorialStore = writable(null)
export const userStore = writable(null)
export const billingStore = writable(null)
export const priceStore = writable(null)
export const incidentStore = writable(null)
export const merchandiseStore = writable(null)
export const stockStore = writable(null)
export const reviewsInvoiceStore = writable(null)
export const reviewsSupportStore = writable(null)
export const userStatisticStore = writable(null)
export const userTracingStore = writable(null)
export const providersInvoiceStore = writable(null)
export const clientStore = writable(null)
export const tracingStore = writable(null)
export const productStore = writable(null)
export const categorieStore = writable(null)
export const errorStore = writable(null)
export const providersPaymentStore = writable(null)
export const providersShoppingStore = writable(null)
export const providersStatusStore = writable(null)

export const accountingIMSSStore = writable(null)
export const accountingIMSSDocumentStore = writable(null)
export const accountingPayrollStore = writable(null)
export const accountingStatementStore = writable(null)


function $modalStore() {

    const store = writable(null)

    store.close = () => store.set(null)
    
    store.open = (type, action = null, data = null) => {

        if(!action && !data)
            return store.set(type)

        type === 'account' && accountStore.set(data)
        type === 'admin' && adminStore.set(data)
        type === 'billing' && billingStore.set(data)
        type === 'charge' && chargeStore.set(data)
        type === 'course' && courseStore.set(data)
        type === 'credit' && creditStore.set(data)
        type === 'facturamaClient' && facturamaClientStore.set(data)
        type === 'fixedprice' && fixedpriceStore.set(data)
        type === 'folio' && folioStore.set(data)
        type === 'invoice' && invoiceStore.set(data)
        type === 'module' && suscriptionStore.set(data)
        type === 'notice' && noticeStore.set(data)
        type === 'notification' && notificationStore.set(data)
        type === 'notify' && notifyStore.set(data)
        type === 'order' && orderStore.set(data)
        type === 'pickup' && pickupStore.set(data)
        type === 'prepaid' && prepaidStore.set(data)
        type === 'price' && priceStore.set(data)
        type === 'pricing' && pricingStore.set(data)
        type === 'merchandise' && merchandiseStore.set(data)
        type === 'provider' && providerStore.set(data)
        type === 'shipment' && shipmentStore.set(data)
        type === 'shopify' && shopifyStore.set(data)
        type === 'stpOrden' && stpOrdenStore.set(data)
        type === 'stock' && stockStore.set(data)
        type === 'ticket' && ticketStore.set(data)
        type === 'tip' && tipStore.set(data)
        type === 'tutorial' && tutorialStore.set(data)
        type === 'user' && userStore.set(data)
        type === 'reviewsInvoice' && reviewsInvoiceStore.set(data)
        type === 'reviewsSupport' && reviewsSupportStore.set(data)
        type === 'userStatistics' && userStatisticStore.set(data)
        type === 'providersInvoice' && providersInvoiceStore.set(data)
        type === 'providersPayment' && providersPaymentStore.set(data)
        type === 'providersShopping' && providersShoppingStore.set(data)
        type === 'providersStatus' && providersStatusStore.set(data)
        type === 'incident' && incidentStore.set(data)
        type === 'imss' && accountingIMSSStore.set(data)
        type === 'imss_document' && accountingIMSSDocumentStore.set(data)
        type === 'payroll' && accountingPayrollStore.set(data)
        type === 'statement' && accountingStatementStore.set(data)
        type === 'client' && clientStore.set(data)
        type === 'tracing' && tracingStore.set(data)
        type === 'error' && errorStore.set(data)

        store.set(`${type}_${action}`)
    }

    return store
}

function items(state = null) {

    const {subscribe, update, set} = writable(state)
    
    return {
        subscribe,
        update,
        set,
        append: (item, pos = 0) => append(item, update, pos),
        replace: item => replace(item, update),
        remove: itemId => remove(itemId, update)
    }
}

function append(item, update, pos = 0) {
    return update(items => {

        if(pos === -1)
            items.push(item)
        else
            items.unshift(item)

        return items
    })
}

function replace(data, update) {
    return update(items => {
        return items.map(item => {
            return item._id === data._id? data : item
        })
    })
}

function remove(itemId, update) {
    return update(items => {
        return items.filter(item => item._id != itemId)
    })
}